/**
 * Narrow on purpose: anything reported is reduced to a scalar at the call site,
 * so a draft, claim, or API response cannot reach a third party by being in
 * scope.
 */
export type AnalyticsProperties = Record<
  string,
  string | number | boolean | null
>;

/**
 * Implemented by the PostHog adapter, and by the do-nothing client below when
 * no project key is configured, so callers never ask whether analytics is on.
 */
export interface AnalyticsClient {
  capture: (event: string, properties?: AnalyticsProperties) => void;
  identify: (distinctId: string, properties?: AnalyticsProperties) => void;
  /** Properties every later event carries, until the next reset. */
  register: (properties: AnalyticsProperties) => void;
  reset: () => void;

  /** Report something that went wrong, with whatever context is known. */
  captureException: (error: Error, properties?: AnalyticsProperties) => void;
}

export const disabledAnalytics: AnalyticsClient = {
  capture() {},
  identify() {},
  register() {},
  reset() {},
  captureException() {},
};
